import { FleetTagCategoryDto } from "generated/graphql";
import { defaultSerializer, SerializerOptions } from "../index";

export const FleetTagCategoryDtoSerializer = {
  type: "FleetTagCategoryDto",
  serializer: (entity: FleetTagCategoryDto, options: SerializerOptions): Partial<FleetTagCategoryDto> | null => {
    if (options?.parent?.__typename === "FleetDto") {
      return defaultSerializer(entity, { level: 0 });
    }

    return defaultSerializer(entity, options);
  },
};
